module.exports = __webpack_public_path__ + "img/1m.93899a02.jpg";